"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var I18n = require("i18n-js");
var rql_1 = require("./rql");
function offersEnabled(listing) {
    return listing.listingType === rql_1.core_apimessages_Listing_ListingType.MAKE_AN_OFFER;
}
function getWatchNudgeText(user, listing) {
    if (!user.loggedOut || offersEnabled(listing))
        return;
    return I18n.t('commons.nudgeManager.watchNudge');
}
exports.getWatchNudgeText = getWatchNudgeText;
function getOfferNudgeText(user) {
    if (user.loggedOut) {
        return I18n.t('commons.nudgeManager.negotiate');
    }
    //   - elsif !safe_current_user.as_buyer.has_made_an_offer?
    return I18n.t('commons.nudgeManager.saveMoney');
}
exports.getOfferNudgeText = getOfferNudgeText;
//# sourceMappingURL=nudge_manager.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/nudge_manager.js
// module id = 1exw
// module chunks = 20 21